export default __webpack_public_path__ + "static/media/jap-ecommerceImg_8.2357c0b7.png";